import { CustomButton } from './styles';
import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import React, { HTMLAttributes, ReactNode } from 'react';
import SVG from 'react-inlinesvg';

export interface ButtonProps extends HTMLAttributes<HTMLButtonElement> {
  theme?: Theme;
  sx?: SxProps<Theme>;
  variant?: 'small' | 'big';
  wide?: boolean;
  boxShadow?: boolean;
  disabled?: boolean;
  icon?: string;
  children?: ReactNode;
}

export const PrimaryRedButton = (props: ButtonProps) => {
  return (
    <CustomButton {...props}>
      {props.icon && <SVG src={props.icon} />}
      {props.children}
    </CustomButton>
  );
};
